import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { autoGrowLayout } from '../../../actions/editor';

import { WidgetsContext } from '../core/context';
import get from 'lodash/get';


export const AutoGrowLayout = React.forwardRef(({ editorSession, breakpoint, widget, children, disabled }, ref) => {
  const dispatch = useDispatch();
  const resizeObserverRef = React.useRef(null);
  const snapshotRef = React.useRef(null);

  const context = React.useContext(WidgetsContext);

  const id = get(widget, 'uid');

  useEffect(() => {
    if (disabled) { 
      return;
    }
    
    setTimeout(() => {
      attachResizeObserver();
    }, 300);

    return () => {
      if (resizeObserverRef.current && ref.current) {
        resizeObserverRef.current.unobserve(ref.current);
      }
    }
  }, [breakpoint, disabled]);

  const attachResizeObserver = () => {
    if (!ref.current || context.development) {
      console.warn(`Target not found`);
      return;
    }

    resizeObserverRef.current = new ResizeObserver(entries => {
      captureSnapshot();
    });

    resizeObserverRef.current.observe(ref.current);
  }

  const captureSnapshot = () => {
    if (!ref.current || context.development) {
      return;
    }

    var height = ref.current.offsetHeight;
    const deviceSnapshot = get(snapshotRef.current, breakpoint);

    if (deviceSnapshot) {
      const previousHeight = get(deviceSnapshot, `height`, 0);

      // if (inlineAsset) {
      //   height = height - previousHeight;
      // }

      const delta = height - previousHeight;

      if (delta == 0) {
        return;
      }

      dispatch(autoGrowLayout(editorSession, breakpoint, id, delta, context?.parentEditorSession));
    }

    snapshotRef.current = {
      ...snapshotRef.current || {},
      [breakpoint]: {
        height: height
      }
    }
  };

  return children;
});
